import {cx} from "@emotion/css";

import {ReactComponent as SvgGrid} from "~/assets/svg/grid.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmGridIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgGrid id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
